<template>
	<div class="survey-container">
		<Nav />
		<span class="overlay" :class="{ active: isMenuOpen || isAccessModalOpen }"></span>
		<div class="header header-standard">
			<HeaderNavBar back survey />
		</div><!-- header -->
		<div class="header-image lblue"></div><!-- header image -->
		<div class="content-wrap content-wrap-alt content-wrap-nav">
			<div class="has-split">
				<SectionTitle
					icon="ShipIcon"
					title="Happy at Sea"
					colour="lblue"
				/>
				<img width="90" class="shi-logo" alt="The Seafarers Happiness Index" src="@/assets/shi-logo.png" />
			</div>
			<div class="section-gap card-wrap">
				<Card
					class="card-block-sky"
					icon="SurveyIcon"
					title="Take our Survey"
					text="Tell us how you feel"
					routeName="SurveyTake"
				/>
				<Card
					routeName="SurveyReports"
					class="card-block-yellow"
					icon="ChartIcon"
					title="View our Reports"
					text="View our quarterly reports"
				/>
			</div><!-- card wrap -->
			<div v-if="results.length" class="section-gap">
				<div class="section-title-wrap">
					<h2 class="section-title">Your Survey Results</h2>
                    <router-link :to="{ name: 'SurveyResults' }" class="page-link page-link-grey">View more &raquo;</router-link>
				</div>
				<div class="card-row-wrap">
					<ScoreCard
                        v-for="result in results"
                        :key="result.uuid"
                        routeName="SurveyResult"
                        :id="result.uuid"
						:type="getMood(result.score)"
                        :score="parseFloat(result.score)"
                        :date="result.created_at | moment('Do MMMM YYYY')"
					/>
				</div><!-- port card wrap -->
			</div>
			<div v-if="reports.length" class="section-gap">
				<div class="section-title-wrap">
					<h2 class="section-title">Our Quarterly Reports</h2>
                    <router-link :to="{ name: 'SurveyReports' }" class="page-link page-link-grey">View more &raquo;</router-link>
				</div>
				<div class="card-row-wrap-alt" v-dragscroll>
					<ReportRow
                        v-for="report in reports"
                        :key="report.id"
						routeName="SurveyReport"
                        :id="report.id"
						class="card-row-block-resources card-row-block-alt card-row-block-report"
						:title="'Q' + report.quarter + ' ' + report.year"
						:score="parseFloat(report.score)"
					/>
				</div><!-- port card wrap -->
				<div class="section-gap card-wrap">
					<Card
						routeName="SurveyResults"
						class="card-block-orange card-block-full"
						icon="ShipIcon"
						title="View your Survey Results History"
					/>
				</div><!-- card wrap -->
			</div>
			<div v-if="featured.length" class="section-gap section-ports">
				<div class="section-title-wrap">
					<h2 class="section-title">Featured Resources</h2>
                    <router-link :to="{ name: 'ResourcesLatest' }" class="page-link page-link-red">View more &raquo;</router-link>
				</div>
				<div class="card-row-wrap-alt" v-dragscroll>
					<CardRow
                        v-for="resource in featured"
                        :key="resource.id"
						eyebrow
						routeName="ResourcesSingle"
                        :id="resource.id"
						class="card-row-block-resources card-row-block-alt"
						:title="resource.title"
						:text="resource.simplified_content"
						:tag="resource.category"
						:type="resource.simplified_type"
					/>
				</div><!-- port card wrap -->
			</div>
		</div>
        <AccessModal/>
		<Menu />
	</div>
</template>
<script>
	import HeaderNavBar from '@/components/HeaderNavBar.vue';
	import Nav from '@/components/Nav.vue';
	import Menu from '@/components/Menu.vue';
	import Card from '@/components/Card.vue';
	import CardRow from '@/components/CardRow.vue';
	import ReportRow from '@/components/ReportRow.vue';
	import SectionTitle from '@/components/SectionTitle.vue';
    import ScoreCard from '@/components/ScoreCard.vue';
    import SurveyService from '@/services/SurveyService';
    import AccessModal from '@/components/AccessModal.vue';
	export default {
		name: 'Survey',
		components: {
            AccessModal,
			Nav,
			HeaderNavBar,
			CardRow,
			Menu,
			Card,
			SectionTitle,
			ScoreCard,
			ReportRow
		},
		data () {
	        return {
                results: [],
                reports: [],
                featured: []
	        };
	    },
	    methods: {
            index () {
                return SurveyService.index().then((response) => {
                    this.results = response.data.results;
                    this.reports = response.data.reports;
                    this.featured = response.data.resources;
                });
            },
            getMood (score) {
                if (score <= 4) {
                    return 'sad';
                }
                if (score > 4 && score < 7) {
                    return 'average';
                }
                if (score >= 7) {
                    return 'happy';
                }
            }
	    },
	    computed: {
			isMenuOpen () {
	            return this.$store.state.isMenuOpen;
	        },
            isAccessModalOpen () {
                return this.$store.state.isAccessModalOpen;
            }
		},
		mounted () {
            this.index();
        }
	};
</script>
<style scoped lang="scss">
	@import "@/assets/scss/_variables.scss";
	@mixin max_width($breakpoint) {
	    @media only screen and (max-width: $breakpoint) { @content; }
	}
	.has-split {
		display: flex;
		justify-content: space-between;
		align-items: center;
		@include max_width(380px) {
			align-items: flex-start;
		}
		.shi-logo {
			margin-left: 15px;
			@include max_width(380px) {
				width: 85px;
			}
		}
	}
</style>
